const DIGITS_MATCH = /^$|^(\+)|(\d+)/g;

export const cleanNumber = (number: string) => number.match(DIGITS_MATCH)?.join('') ?? '';
